import { useMutation } from "react-query";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deletePlace = ({ placeId }: { placeId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/Places/DeletePlace/${placeId}`);
};

type QueryFnType = typeof deletePlace;

type UseDeletePlaceOptions = {
  placeId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeletePlace = ({ config }: UseDeletePlaceOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στην διαγραφή της Τοποθεσίας.`, 500);
      console.error("Couldnt delete Place", error);
      setIsNotificationVisible(true);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllPlaces"]);
      addNotification(`Η Τοποθεσία Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deletePlace,
  });
};
